import { render, staticRenderFns } from "./afterSale_detail.vue?vue&type=template&id=5e3028d6&scoped=true&"
import script from "./afterSale_detail.vue?vue&type=script&lang=ts&"
export * from "./afterSale_detail.vue?vue&type=script&lang=ts&"
import style0 from "./afterSale_detail.vue?vue&type=style&index=0&id=5e3028d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3028d6",
  null
  
)

export default component.exports